"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.sanitizeKey = void 0;
const sanitizeKey = key => key.startsWith('#') ? key.slice(1) : key;
exports.sanitizeKey = sanitizeKey;